
export default {
  name: 'UserInfo',
  data() {
    return {
      showNotice: false,
      showAccount: false,
      noticeActions: [
        {
          text: '站内信',
          icon: 'chat-o',
          linkto: 'notice'
        },
        {
          text: '推广返利',
          icon: 'gift-o',
          linkto: 'popularize'
        },
        {
          text:'站点工具',
          icon: 'points',
          linkto: 'sitetools'
        }
      ],
      accountActions: [
        {
          text: '当前余额：',
          icon: 'balance-pay',
          linkto: 'recharge'
        },
        {
          text: '在线工单',
          icon: 'records',
          linkto: 'workorderlist'
        },
        {
          text: '我的套餐',
          icon: 'user-o',
          linkto: 'mystuff'
        },
        {
          text: '财务中心',
          icon: 'cash-back-record',
          linkto: 'financialcenter'
        },
        {
          text: '账号设置',
          icon: 'setting-o',
          linkto: 'setup'
        },
        {
          text: '退出登录',
          icon: 'close',
          linkto: 'logout'
        }
      ]
    }
  },
  methods: {
    onAccount(action) {
      this.showAccount = false
      this.$router.push(action.linkto)
    },
    onNotice(action) {
      this.showNotice = false
      // 点击推广返利时
      if (action.linkto === 'popularize') {
        // 判断是否开通了推广返利
        if (this.$store.state.daili === 0) {
          this.$router.push(action.linkto)
        } else if (this.$store.state.daili === 1) {
          this.$router.push('popularizeinfo')
        }
      } else {
        this.$router.push(action.linkto)
      }
    }
  }
}
